import { registerLeadFilterSection } from "@/features/leads/components/leadFilter/registry";
import { LEAD_FILTER_INDUSTRY_IDS } from "@/features/leads/components/leadFilter/config/leadFilterIndustryConfig";
import StudyPreferences from "@/features/leads/components/leadFilter/components/StudyPreferences/studyPreferences";
import AcademicBackground from "@/features/leads/components/leadFilter/components/AcademicBackground/acadamicBackground";
import {
  academicKeywords,
  studyPreferencesKeywords,
} from "@/features/leads/components/leadFilter/keywords";

const EDU_INDUSTRIES = [
  LEAD_FILTER_INDUSTRY_IDS.STUDY_ABROAD,
  LEAD_FILTER_INDUSTRY_IDS.EDUCATION,
];

registerLeadFilterSection({
  id: "academic",
  industryIds: EDU_INDUSTRIES,
  title: "Academic Background",
  searchKeywords: academicKeywords,
  render: () => <AcademicBackground />,
});

registerLeadFilterSection({
  id: "preference",
  industryIds: EDU_INDUSTRIES,
  title: "Study Preferences",
  searchKeywords: studyPreferencesKeywords,
  render: () => <StudyPreferences />,
});
